module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f44e.66e3cbf5.svg";